import { Grid, GridItem, Link, Text } from "@chakra-ui/react";
import { FilledButton } from "./Button";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import AppointButton from "./AppointButton";
import CustomCard from "./CustomCard";
import { Link as RouterLink } from "react-router-dom";

const TaxGrid = ({ services }) => {
  return (
    <Grid
      templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
      gap={6}
      p={6}
      px={{ base: "5", md: "10", lg: "20" }}
      data-aos="zoom-in"
    >
      {/* First Card (Spanning Two Columns) */}
      <GridItem
        colSpan={{ base: 1, md: 2 }}
        bgGradient="linear-gradient(to bottom, #178CA4, #4FC3C0);"
        p={6}
        borderRadius="3xl"
        boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
        color="white"
      >
        <Text fontSize="xl" fontWeight="bold" mb={4}>
          {services[0].title}
        </Text>
        <Text mb={4}>{services[0].description}</Text>
        <AppointButton
          text={
            <FilledButton
              color="black"
              backgroundColor="#fff"
              title={services[0].buttonText}
            />
          }
        />
      </GridItem>

      {/* Remaining Cards in Next Row */}
      {services.slice(1).map((item, index) => (
        <CustomCard
          title={item.title}
          description={item.description}
          borderRadius="3xl"
          boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px;"
          lineClamp="3"
          children={
            <Link
              as={RouterLink}
              transition="all 0.3s ease-in-out"
              _hover={{ textDecor: "none", gap: 3 }}
              fontWeight="semibold"
              color="#66b2b2"
              to={item.url}
              _focus={{ outline: "none" }}
            >
              {item.buttonText}
              <IoArrowForwardCircleOutline size={22} />
            </Link>
          }
        />
      ))}
    </Grid>
  );
};

export default TaxGrid;
